import React, { useEffect, useState } from "react";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper,
  Box,
  Typography,
  Button
} from "@mui/material";
import axios from "axios";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { hasPermission } from "src/components/Permissions/hasPermission";
import { useNavigate } from "react-router";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import { get } from "src/services/httpClient.service";

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

interface Vendor {
  vendorMail: string;
  vendorName: string;
  vendorContactNo: string;
  //streamEngine: string;
  streamEngineUrl: string;
  channelPort: string;
  apiPort: string;
  galleryPort: string;

  hasDrmAccess: boolean;
  drmUrl: string;
  drmUserName: string;
  drmLicenseKey: string;

  enableCommonGallery: boolean;
  fileUploadUrl: string;
  fileUploadPort: string;
  status: string;

  enableMediaServer: boolean;
  enableCommonMediaServer: boolean;
  mediaServerUrl: string;
  mediaServerChannelPort: string;

  enablePublicUrl: boolean;
  enableCommonPublicUrl: boolean;
  publicUrl: string;
  publicChannelPort: string;
  mobilePackageName: string;
  tvPackageName: string;
}

const VendorDetails = () => {
   const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [rows, setRows] = useState<Vendor[]>([]);

  // -------- Columns inside function --------
  const columns = [
    { field: "vendorMail", header: "Vendor Mail" },
    { field: "vendorName", header: "Vendor Name" },
    { field: "vendorContactNo", header: "Contact No" },
    { field: "streamEngine", header: "Stream Engine Type" },
    { field: "streamEngineUrl", header: "Engine URL" },
    { field: "channelPort", header: "Channel Port" },
    { field: "apiPort", header: "API Port" },
    // { field: "galleryPort", header: "Gallery Port" },

    // DRM
    { field: "hasDrmAccess", header: "Has DRM Access" },
    // { field: "drmUrl", header: "DRM URL" },
    // { field: "drmUserName", header: "DRM Username" },
    // { field: "drmLicenseKey", header: "DRM License Key" },

    // Gallery
    // { field: "enableCommonGallery", header: "Enable Common Gallery" },
    // { field: "fileUploadUrl", header: "File Upload URL" },
    // { field: "fileUploadPort", header: "File Upload Port" },
    { field: "status", header: "Status" },

    // Media Server
    { field: "enableMediaServer", header: "Enable Media Server" },
    { field: "enableCommonMediaServer", header: "Enable Common Media Server" },
    { field: "mediaServerUrl", header: "Media Server URL" },
    { field: "mediaServerChannelPort", header: "Media Server Channel Port" },

    // Public URL
    { field: "enablePublicUrl", header: "Enable Public URL" },
    { field: "enableCommonPublicUrl", header: "Enable Common Public URL" },
    { field: "publicUrl", header: "Public URL" },
    { field: "publicChannelPort", header: "Public Channel Port" },

    { field: "mobilePackageName", header: "Mobile Package" },
    { field: "tvPackageName", header: "TV Package" },

    //actions
    { field: "actions", header: "Actions" },

  
  ];

  // -------- API Call --------
  const fetchVendors = async () => {
    try {
      const response = await get(`${API_BASE_URL}/api/vendors`);
      setRows(response || []);
    } catch (error) {
      showSnackbar(error?.message || "Error fetching vendors:",'error' )
     
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  return (
    <Box sx={{ p: 3 }}>

        <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center', 
                  mb: 3 
                }}>
                  <Typography variant="h4" component="h1">
                    Vendors Details
                  </Typography>
                {
                    hasPermission(["OWNER"]) && (<Button
                    variant="contained" 
                    color="primary" 
                    startIcon={<AddIcon />}
                    onClick={() => navigate('/vendors/Addvendor')}
                  >
                    Add New Vender
                    </Button>)
                }
        
                </Box>

        <TableContainer component={Paper}>
  <Table>

    {/* TABLE HEADER */}
    <TableHead>
      <TableRow>
        {columns.map((col, i) => (
          <TableCell key={i}>{col.header}</TableCell>
        ))}
      </TableRow>
    </TableHead>

    {/* TABLE BODY */}
    <TableBody>
      {rows.map((row, rIndex) => (
        <TableRow key={rIndex}>
          {columns.map((col, cIndex) => (
            <TableCell key={cIndex}>
              {col.field === "actions" ? (
                <EditIcon
                  sx={{ cursor: "pointer",color:'blue' }}
                  onClick={() =>  navigate(`/vendors/Updatevendor/${(row as any).vendorId}`)}
                />
              ) : (
                String(row[col.field as keyof Vendor])
              )}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>

  </Table>
</TableContainer>

    </Box>
    
  );
};

export default VendorDetails;
